import { MessageCircle } from "lucide-react";
import { CONTACT } from "./site";

export const WhatsAppFloat = () => (
    <a
        href={CONTACT.whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with YNova Education on WhatsApp"
        data-testid="whatsapp-float-button"
        className="fixed right-6 bottom-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-sun text-ground-deep shadow-2xl shadow-sun/30 transition-transform duration-200 hover:scale-110 focus:ring-2 focus:ring-sun focus:ring-offset-2 focus:ring-offset-ground-deep focus:outline-none"
    >
        <MessageCircle className="h-7 w-7" strokeWidth={2.2} />
    </a>
);
